import { render } from "./LegalEntityForm.vue?vue&type=template&id=5240d300"
import script from "./LegalEntityForm.vue?vue&type=script&lang=js"
export * from "./LegalEntityForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tasselchof/CodeProjects/oarus/oarus-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__